module.exports = __webpack_public_path__ + "media/gold_music.e5e796d0.mp3";